import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import styled, { css } from 'styled-components';
import { Typography } from '../../Typography';
import { mouseCursor } from '../../../styling';
import { ExpansionIndicator } from '../../ExpansionIndicator';
import { color, typography, propsBlocker } from '../../../system';

var accordionHeaderStyle = function accordionHeaderStyle(_ref) {
  var disabled = _ref.disabled,
      isExpanded = _ref.isExpanded,
      Root = _ref.theme.componentOverrides.AccordionHeader.Root;

  if (disabled) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral([" pointer-events: none; ", "", ""])), Root.base, Root.disabled);
  }

  return isExpanded ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", "", ""])), Root.base, Root.expanded) : Root.base;
};

var accordionHeaderTypographyStyle = function accordionHeaderTypographyStyle(_ref2) {
  var disabled = _ref2.disabled,
      HeaderTypography = _ref2.theme.componentOverrides.AccordionHeader.Typography;

  if (disabled) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", "", ""])), HeaderTypography.base, HeaderTypography.disabled);
  }

  return HeaderTypography.base;
};

export var AccordionHeaderRoot = styled.div.withConfig(propsBlocker)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    align-items: center;\n    box-sizing: border-box;\n    display: inline-flex;\n    min-height: 56px;\n    justify-content: space-between;\n\n    ", ";\n    ", ";\n    ", ";\n"])), typography('labelMedium'), mouseCursor, accordionHeaderStyle);
export var AccordionHeaderTypography = styled(Typography)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", ";\n"])), accordionHeaderTypographyStyle);
export var AccordionHeaderBody = styled(Typography)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    align-items: center;\n    display: inline-flex;\n"])));

var accordionExpansionIndicatorStyle = function accordionExpansionIndicatorStyle(_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n              .ExpansionIndicator-Icon {\n                  color: ", ";\n              }\n          "])), color('neutral.04')) : {};
};

export var AccordionHeaderExpansionIndicator = styled(ExpansionIndicator)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    .AccordionHeader-ExpansionIndicator.ExpansionIndicator-Content {\n        width: 56px;\n    }\n\n    ", ";\n"])), accordionExpansionIndicatorStyle);
export var AccordionHeaderIcon = styled.div.withConfig(propsBlocker)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    ", ";\n"])), accordionHeaderTypographyStyle);